module.exports = __webpack_public_path__ + "img/1-white.f9d473aa.svg";